import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import fetchRelayPortalAccounts from './useRelayPortalAccounts.request';
import { RelayPortalAccountsResponse } from './useRelayPortalAccounts.interface';

const useRelayPortalAccounts = <T = RelayPortalAccountsResponse>(
    memberId: number | string | undefined,
    options?: Omit<UseQueryOptions<RelayPortalAccountsResponse, AxiosError, T>, 'queryKey' | 'queryFn'>
) => {
    return useQuery({
        queryKey: ['relayPortalAccounts', memberId],
        queryFn: () => fetchRelayPortalAccounts(memberId!),
        enabled: Boolean(memberId),
        retry: false,
        refetchOnReconnect: false,
        refetchOnWindowFocus: false,
        ...options,
    });
};

export default useRelayPortalAccounts;
